import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo component
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix
import { devConfig, providersCasino, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the filter deposit reports view.
 */
export default class FilterDepositReportsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing date picker and date input
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for date range
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
                {
                    view: 'datepicker', // Date picker input
                    name: 'Date',
                    id: 'Date',
                    stringResult: true,
                    minWidth: 200,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                    format: '%d %M %Y', // Date format
                    suggest: {
                        type: 'calendar',
                        body: {
                            maxDate: new Date(), // Maximum selectable date is today
                        },
                    },
                },
            ],
        };

        // Center left section containing type selection
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Dropdown for selecting type
                    name: 'Type',
                    localId: 'provider:combo',
                    label: _('Tipo'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        { id: '0', value: _('Mensual') }, // Monthly option
                        { id: '1', value: _('Diario') }, // Daily option
                    ],
                },
            ],
        };

        // Section for transaction ID input
        const transactionId = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for transaction ID
                    name: 'TransactionId',
                    type: 'number',
                    label: _('Transacción ID'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Transacción ID'), // Placeholder text
                    invalidMessage: _('Transacción ID is required'), // Error message
                },
            ],
        };

        // Center right section for BetShop selection
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo', // Combo box for BetShop selection
                    name: 'BetShopId',
                    label: "<span class='icon-shop'></span>" + _('Punto de Venta'), // Localized label
                    hidden: !devConfig.getPermAction('filterByBetShop', 'Add'), // Conditional visibility
                    css: 'prm-filterByBetShop',
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    id: 'BetShopId',
                    options: {
                        body: {
                            dataFeed: function (text) {
                                // Function to fetch BetShop data
                                var vthis = this;
                                if (text.length > 2) {
                                    // Trigger data fetch if input length is greater than 2
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'es/Select/BetShopsSelect',
                                            '{"Filter":"' + text + '"}', // Sending filter text
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Error message on failure
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var resp = JSON.parse(text); // Parsing response
                                                    if (!resp.HasError) {
                                                        vthis.parse(resp.Data); // Parsing data into combo
                                                    }
                                                },
                                            },
                                        );
                                }
                            },
                        },
                    },
                },
            ],
        };

        // Upper section containing the three main input sections
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right], // Arranging left, center left, and center right sections
                },
            ],
        };

        // Buttons for clearing and submitting the form
        const buttons = {
            margin: 10,
            minWidth: 200,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Localized label
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form inputs
                    },
                },
                {
                    view: 'button', // Submit button
                    value: _('Consultar'), // Localized label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('depositReport:filter', [
                            filterdata, // Triggering filter event with form data
                        ]);
                        $$('b5').collapse(); // Collapse the filter section
                    },
                },
            ],
        };

        // Accordion section containing filters and buttons
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion view for collapsible sections
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Localized header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Including upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Returning the main form configuration
        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section], // Main content of the form
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object passed to the init method.
     */
    init(grid) {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date input if typeDate is not 2
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date input if typeDate is 2
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
